import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigurableMode } from './ConfigurableMode';
import { useSurvey } from '@/hooks/app';
import { SwiperItemAttrs } from '../../SwiperConfigable';
import moment from 'jalali-moment';
import { getSurveySwiperImage } from '@/components/SwiperConfigable/func';
import { useNavigate } from 'react-router-dom';
import { Routes } from '@/routes';

export default function SurveyMode() {

  const navigate = useNavigate();
  const [t] = useTranslation(['common', 'survey']);
  const { surveys, fetchSurvey, loading, error } = useSurvey();

  useEffect(() => {
    fetchSurvey();
  }, []);

  const navigateToSurvey = (item: SwiperItemAttrs) => navigate(Routes.SurveyParticipate.replace(':surveyId', String(item.id)));

  const items: SwiperItemAttrs[] = surveys?.map((item) => {
    const typeLabel = t(`common:labels.survey-${item.type}`, { defaultValue: t('common:labels.unknown') });

    return {
      id: item?.id,
      title: `${item.name ?? t('common:labels.unknown')} `,
      startServeTime: moment.from(item?.fromDate, 'en').format('jDD jMMMM HH:mm'),
      endServeTime: moment.from(item?.toDate, 'en').format('jDD jMMMM HH:mm'),
      foodImageSrc: getSurveySwiperImage(item.type),
      actionButtonContent: `${t('survey:labels.participate-in')} ${typeLabel}`,
    };
  });

  return (
    <ConfigurableMode
      items={items}
      error={error}
      loading={loading}
      variant="survey"
      onActionClick={navigateToSurvey}
    />
  );
}
